import { type WritableAtom, atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { SetStateAction } from 'react';

import { CameraSourceOffItem } from 'lib/api/manuel-control';
import { DEFAULT_ROTATION_AXIS_HEIGHT } from 'lib/constants/variables';

/**
 * @type {spot_msgs.msg.BodyPose}
 */
export type RobotRotationAxes = {
  roll: number;
  pitch: number;
  yaw: number;
  height: number;
};

export type RobotSpeed = number;

export type RobotControlState = {
  speed: RobotSpeed;
  rotationAxes: RobotRotationAxes;
  isRotationAxesLocked: boolean;
};

const defaultRobotControlState: RobotControlState = {
  speed: 0.59,
  rotationAxes: {
    roll: 0,
    pitch: 0,
    yaw: 0,
    height: DEFAULT_ROTATION_AXIS_HEIGHT,
  },
  isRotationAxesLocked: false,
};

// todo - having a atomFamily make no sense when we don't use this for myRobotInfoAtom as well
// todo:jl - find out why we have a atomFamily based on a selectorFamily
export const robotControlAtom = atomFamily<
  string,
  WritableAtom<RobotControlState, [SetStateAction<RobotControlState>], void>
>(() => {
  const valueAtom = atom(defaultRobotControlState);
  valueAtom.debugLabel = 'Robot Control';
  return valueAtom;
});

export const selectedCameraSourceAtom = atomFamily(() => {
  const valueAtom = atom(CameraSourceOffItem);
  valueAtom.debugLabel = 'Robot Control/Selected Camera Source';
  return valueAtom;
});
